// extracted by mini-css-extract-plugin
export var text = "_bt-0";